import {
    Badge,
    Button,
    Pagination,
    PaginationItem,
    PaginationLink,
    Table
} from "reactstrap";

import { useNavigate } from "react-router-dom";

import GroupService from "../Services/GroupService";
import { GroupDto } from "../types/Group";
import { useState } from "react";
import DeleteGroupModal from "./DeleteGroupModal";
interface Props {

    groups: GroupDto[];

    refresh: () => void;

}

const GroupTable = ({
    groups,
    refresh
}: Props) => {
    const [deleteModal, setDeleteModal] =
        useState(false);

    const [selectedGroup,
        setSelectedGroup] =
        useState<GroupDto | null>(null);

    const [deleting,
        setDeleting] =
        useState(false);
    const navigate =
        useNavigate();

        const [currentPage, setCurrentPage] = useState(1);
        const itemsPerpage = 15;
        const totalPage = Math.ceil(groups.length/ itemsPerpage);
        const startIndex = (currentPage -1)* itemsPerpage;
        const endIndex = startIndex + itemsPerpage;
        const currentGroups = groups.slice(startIndex,endIndex);

    const openDelete = (
        group: GroupDto
    ) => {

        setSelectedGroup(group);

        setDeleteModal(true);

    };
    const deleteGroup = async () => {

        if (!selectedGroup)
            return;

        setDeleting(true);

        try {

            await GroupService.delete(
                selectedGroup.groupId
            );

            refresh();

            setDeleteModal(false);

        }
        finally {

            setDeleting(false);

        }

    };

    return (

<div className="admin-group-table">
    <Table
        hover
        responsive
        bordered
        className="align-middle shadow-sm"
    >
  <thead
    style={{
      background: "linear-gradient(90deg,#2563eb,#4f46e5)",
      color: "#fff",
      textAlign: "center",
    }}
  >
    <tr>
      <th>#</th>
      <th>Group Name</th>
      <th>Category</th>
      <th>Type</th>
      <th>Region</th>
      <th>State</th>
      <th>District</th>
      <th>Members</th>
      <th>Amount</th>
      <th>Group Payment</th>
      <th>Status</th>
      <th>Actions</th>
    </tr>
  </thead>

  <tbody>
    {currentGroups.map((group, index) => (
      <tr
        key={group.groupId}
        style={{ textAlign: "center", verticalAlign: "middle" }}
      >
        <td>{startIndex + index + 1}</td>

        <td className="fw-bold">{group.groupName}</td>

        <td>{group.category}</td>

        <td>
          <Badge color="info" pill>
            {group.type}
          </Badge>
        </td>

        <td>{group.region}</td>

        <td>{group.state || "-"}</td>

        <td>{group.district || "-"}</td>

        <td>
          <Badge color="primary" pill>
            {group.totalMembers}
          </Badge>
        </td>

        <td>
          {group.isPaymentRequired ? (
            <Badge color="success" pill>
              ₹{group.amount}
            </Badge>
          ) : (
            <Badge color="secondary" pill>
              FREE
            </Badge>
          )}
        </td>

        <td>
          {group.isPaymentRequired ? (
            <Badge color="warning" pill>
              ₹{group.groupPayment ?? 0}
            </Badge>
          ) : (
            "-"
          )}
        </td>

        <td>
          <Badge
            color={group.isActive ? "success" : "danger"}
            pill
          >
            {group.isActive ? "Active" : "Inactive"}
          </Badge>
        </td>

        <td>
          <div className="d-flex justify-content-center gap-2">
            <Button
              color="warning"
              size="sm"
              className="rounded-pill px-3"
              onClick={() =>
                navigate(`/admin/groups/edit/${group.groupId}`)
              }
            >
              ✏ 
            </Button>

            <Button
              color="danger"
              size="sm"
              className="rounded-pill px-3"
              onClick={() => openDelete(group)}
            >
              🗑 
            </Button>
          </div>
        </td>
      </tr>
    ))}
  </tbody>

  <DeleteGroupModal
    isOpen={deleteModal}
    groupName={selectedGroup?.groupName ?? ""}
    toggle={() => setDeleteModal(false)}
    onDelete={deleteGroup}
    loading={deleting}
  />
</Table>
<div className="d-flex justify-content-between align-items-center mt-3">

  <div>
    Showing{startIndex +1} - {Math.min(endIndex, groups.length)} of {groups.length} Groups
  </div>
  <Pagination>
    <PaginationItem  disabled = {currentPage === 1}>
     <PaginationLink
    previous
    className="bg-primary text-white border-primary"
    onClick={() => setCurrentPage(currentPage - 1)}
/>

    </PaginationItem>

 
    <PaginationItem disabled = {currentPage === totalPage }>
<PaginationLink
next
className="bg-primary text-white border-primary"
onClick={() => setCurrentPage(currentPage + 1)}
/>

    </PaginationItem>


  </Pagination>
</div>
</div>

    );

};

export default GroupTable;